 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import CONTENTCONTENT0013 from '@/components/content/content-0013'
 import CONTENTCONTENT0020 from '@/components/content/content-0020'
 import CONTENTCONTENT0022 from '@/components/content/content-0022'
 import CONTENTCONTENT0023 from '@/components/content/content-0023'
 import CONTENTCONTENT0028 from '@/components/content/content-0028'
 import CONTENTCONTENT0031 from '@/components/content/content-0031'
 import CONTENTCONTENT0035 from '@/components/content/content-0035'
 import CONTENTCONTENT0036 from '@/components/content/content-0036'
 import CONTENTCONTENT0042 from '@/components/content/content-0042'
 import CONTENTCONTENT0045 from '@/components/content/content-0045'
 import CONTENTCONTENT0047 from '@/components/content/content-0047'
 import CONTENTCONTENT0048 from '@/components/content/content-0048'
 import CONTENTCONTENT0051 from '@/components/content/content-0051'
 import CONTENTCONTENT0052 from '@/components/content/content-0052'
 import CONTENTCONTENT0055 from '@/components/content/content-0055'
 import CONTENTCONTENT0056 from '@/components/content/content-0056'
 import CONTENTCONTENT0059 from '@/components/content/content-0059'
 import CONTENTCONTENT0061 from '@/components/content/content-0061'
 import CONTENTCONTENT0064 from '@/components/content/content-0064'
 import CONTENTCONTENT0066 from '@/components/content/content-0066'
 import CONTENTCONTENT0070 from '@/components/content/content-0070'
 import CONTENTCONTENT0071 from '@/components/content/content-0071'
 import CONTENTCONTENT0074 from '@/components/content/content-0074'
 import CONTENTCONTENT0077 from '@/components/content/content-0077'
 import CONTENTCONTENT0078 from '@/components/content/content-0078'
 import CONTENTCONTENT0080 from '@/components/content/content-0080'
 import CONTENTCONTENT0089 from '@/components/content/content-0089'
 import CONTENTCONTENT0092 from '@/components/content/content-0092'
 import CONTENTCONTENT0094 from '@/components/content/content-0094'
 import CONTENTCONTENT0097 from '@/components/content/content-0097'
 import CONTENTCONTENT0101 from '@/components/content/content-0101'
 import CONTENTCONTENT0102 from '@/components/content/content-0102'
 import CONTENTCONTENT0105 from '@/components/content/content-0105'
 import CONTENTCONTENT0106 from '@/components/content/content-0106'
 import CONTENTCONTENT0108 from '@/components/content/content-0108'
 import CONTENTCONTENT0111 from '@/components/content/content-0111'
 import CONTENTCONTENT0112 from '@/components/content/content-0112'
 import CONTENTCONTENT0115 from '@/components/content/content-0115'
 import CONTENTCONTENT0121 from '@/components/content/content-0121'
 import CONTENTCONTENT0123 from '@/components/content/content-0123'
 import CONTENTCONTENT0126 from '@/components/content/content-0126'
 import CONTENTCONTENT0127 from '@/components/content/content-0127'
 import CONTENTCONTENT0132 from '@/components/content/content-0132'
 import CONTENTCONTENT0135 from '@/components/content/content-0135'
 import CONTENTCONTENT0137 from '@/components/content/content-0137'
 import CONTENTCONTENT0141 from '@/components/content/content-0141'
 import CONTENTCONTENT0144 from '@/components/content/content-0144'
 import CONTENTCONTENT0146 from '@/components/content/content-0146'
 import CONTENTCONTENT0149 from '@/components/content/content-0149'
 import CONTENTCONTENT0150 from '@/components/content/content-0150'
 import CONTENTCONTENT0153 from '@/components/content/content-0153'
 import CONTENTCONTENT0154 from '@/components/content/content-0154'
 import CONTENTCONTENT0157 from '@/components/content/content-0157'
 import CONTENTCONTENT0162 from '@/components/content/content-0162'
 import CONTENTCONTENT0164 from '@/components/content/content-0164'
 import CONTENTCONTENT0168 from '@/components/content/content-0168'
 import CONTENTCONTENT0169 from '@/components/content/content-0169'
 import CONTENTCONTENT0171 from '@/components/content/content-0171'
 import CONTENTCONTENT0173 from '@/components/content/content-0173'
 import CONTENTCONTENT0175 from '@/components/content/content-0175'
 import CONTENTCONTENT0179 from '@/components/content/content-0179'
 import CONTENTCONTENT0180 from '@/components/content/content-0180'
 import CONTENTCONTENT0185 from '@/components/content/content-0185'
 import CONTENTCONTENT0195 from '@/components/content/content-0195'
 import CONTENTCONTENT0196 from '@/components/content/content-0196'
 import CONTENTCONTENT0199 from '@/components/content/content-0199'
 import CONTENTCONTENT0201 from '@/components/content/content-0201'
 import CONTENTCONTENT0204 from '@/components/content/content-0204'
 import CONTENTCONTENT0206 from '@/components/content/content-0206'
 import CONTENTCONTENT0207 from '@/components/content/content-0207'
 import CONTENTCONTENT0210 from '@/components/content/content-0210'
 import CONTENTCONTENT0212 from '@/components/content/content-0212'
 import CONTENTCONTENT0215 from '@/components/content/content-0215'
 import CONTENTCONTENT0216 from '@/components/content/content-0216'
 import CONTENTCONTENT0223 from '@/components/content/content-0223'
 import CONTENTCONTENT0225 from '@/components/content/content-0225'
 import CONTENTCONTENT0226 from '@/components/content/content-0226'
 import CONTENTCONTENT0229 from '@/components/content/content-0229'
 import CONTENTCONTENT0230 from '@/components/content/content-0230'
 import CONTENTCONTENT0233 from '@/components/content/content-0233'
 import CONTENTCONTENT0234 from '@/components/content/content-0234'
 import CONTENTCONTENT0237 from '@/components/content/content-0237'
 import CONTENTCONTENT0239 from '@/components/content/content-0239'
 import CONTENTCONTENT0241 from '@/components/content/content-0241'
 import CONTENTCONTENT0242 from '@/components/content/content-0242'
 import CONTENTCONTENT0245 from '@/components/content/content-0245'
 import CONTENTCONTENT0247 from '@/components/content/content-0247'
 import CONTENTCONTENT0250 from '@/components/content/content-0250'
 import CONTENTCONTENT0256 from '@/components/content/content-0256'
 import CONTENTCONTENT0259 from '@/components/content/content-0259'
 import CONTENTCONTENT0264 from '@/components/content/content-0264'
 import CONTENTCONTENT0267 from '@/components/content/content-0267'
 import CONTENTCONTENT0269 from '@/components/content/content-0269'
 import CONTENTCONTENT0279 from '@/components/content/content-0279'
 import CONTENTCONTENT0283 from '@/components/content/content-0283'
 import CONTENTCONTENT0291 from '@/components/content/content-0291'
 import CONTENTCONTENT0295 from '@/components/content/content-0295'
 import CONTENTCONTENT0296 from '@/components/content/content-0296'
 import CONTENTCONTENT0299 from '@/components/content/content-0299'
 import CONTENTCONTENT0305 from '@/components/content/content-0305'
 import CONTENTCONTENT0307 from '@/components/content/content-0307'
 import CONTENTCONTENT0316 from '@/components/content/content-0316'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/content/content-0013",
 			"name" : "content/content-0013",
 			"component" : CONTENTCONTENT0013
 		},
 		{
 			"path" : "/content/content-0020",
 			"name" : "content/content-0020",
 			"component" : CONTENTCONTENT0020
 		},
 		{
 			"path" : "/content/content-0022",
 			"name" : "content/content-0022",
 			"component" : CONTENTCONTENT0022
 		},
 		{
 			"path" : "/content/content-0023",
 			"name" : "content/content-0023",
 			"component" : CONTENTCONTENT0023
 		},
 		{
 			"path" : "/content/content-0028",
 			"name" : "content/content-0028",
 			"component" : CONTENTCONTENT0028
 		},
 		{
 			"path" : "/content/content-0031",
 			"name" : "content/content-0031",
 			"component" : CONTENTCONTENT0031
 		},
 		{
 			"path" : "/content/content-0035",
 			"name" : "content/content-0035",
 			"component" : CONTENTCONTENT0035
 		},
 		{
 			"path" : "/content/content-0036",
 			"name" : "content/content-0036",
 			"component" : CONTENTCONTENT0036
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js